import { h } from '@stencil/core';
import { PRODUCTS_PLACEHOLDER } from '@pes-ui/utils';
import cn from 'classnames';
import { grid, MAX_TOP_RUNNERS } from './constants';
const CARD_OFFSET_WIDTH = 220;
export class TopRunners {
  constructor() {
    this.createSliderRef = (el) => {
      this.sliderRef = el;
    };
    this.resizeWindow = () => {
      this.cardsPerSlide = this.calcItemsPerSlide();
    };
    this.list = undefined;
    this.viewOnLabel = undefined;
    this.productsLabel = undefined;
    this.smallCard = false;
    this.isMobile = undefined;
    this.isActive = false;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.cardsPerSlide = undefined;
  }
  calcItemsPerSlide() {
    if (this.sliderRef) {
      return this.sliderRef.offsetWidth / CARD_OFFSET_WIDTH;
    }
  }
  isTopRunnerCardLarge(itemIndex) {
    var _a;
    const totalCount = this.list.length;
    return (_a = grid[totalCount]) === null || _a === void 0 ? void 0 : _a.includes(itemIndex);
  }
  renderCard(runner, isLarge = false) {
    const key = `${runner.id}${this.isActive ? '_active' : ''}`;
    return (h("pes-card", { key: key, page: "range", item: Object.assign(Object.assign({}, runner), { sourceId: runner.sourceId || runner.id.replace(/[A-Za-z_]/gi, '') }), viewOnLabel: this.viewOnLabel, labelTemplate: this.productsLabel, labelPlaceholder: PRODUCTS_PLACEHOLDER, size: (this.smallCard && 'small') || (isLarge && 'large'), breadcrumbs: this.breadcrumbs, storageName: this.storageName }));
  }
  componentWillLoad() {
    window.addEventListener('resize', this.resizeWindow);
  }
  componentDidLoad() {
    this.cardsPerSlide = this.calcItemsPerSlide();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  render() {
    var _a, _b;
    if (this.isMobile) {
      return (h("section", { class: "top-runners" }, h("div", { class: "top-runners__slider" }, h("pdp-slider", { ref: this.createSliderRef, class: "media-gallery-mobile", childrenClassName: ".mobile-gallery-slide", itemsPerSlide: this.cardsPerSlide, showPointers: true, showButtons: false, smallPoint: true, smallCard: this.smallCard }, this.list.map((runner) => this.renderCard(runner))))));
    }
    return (h("section", { class: "top-runners" }, (_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.slice(0, MAX_TOP_RUNNERS)) === null || _b === void 0 ? void 0 : _b.map((runner, index) => {
      const isCardLarge = this.isTopRunnerCardLarge(index);
      return (h("div", { class: cn('top-runners__card', { 'top-runners__card--large': isCardLarge }) }, this.renderCard(runner, isCardLarge)));
    })));
  }
  static get is() { return "pes-top-runners"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["top-runners.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["top-runners.css"]
    };
  }
  static get properties() {
    return {
      "list": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllToprunners[]",
          "resolved": "ProductsAllToprunners[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-label",
        "reflect": false
      },
      "smallCard": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "small-card",
        "reflect": false,
        "defaultValue": "false"
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      },
      "isActive": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-active",
        "reflect": false,
        "defaultValue": "false"
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "cardsPerSlide": {}
    };
  }
}
